import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { API_URL } from "../../../config";

function PayPage() {
  const { invoiceId } = useParams();
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [paying, setPaying] = useState(false);

  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/getInvoiceById/${invoiceId}`);
        const data = res.data?.invoice || null;

        if (!data) {
          setError("Invoice not found");
        } else {
          setInvoice(data);
        }
      } catch (err) {
        console.error(err);
        setError("Failed to fetch invoice. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchInvoice();
  }, [invoiceId]);

  const handlePayment = async () => {
    if (!invoice) {
      alert("Invoice data not available.");
      return;
    }

    try {
      setPaying(true);

      const amount = Number(invoice.remainingAmount || invoice.totalAmount || 0);
      if (amount <= 0) {
        alert("Invoice is already fully paid.");
        return;
      }

      await axios.post(`${API_URL}/api/invoices/${invoice._id}/addPayment`, {
        amount,
        method: "Online",
        bankName: "Online Gateway",
        note: "Paid from Pay Page",
      });

      const res = await axios.get(`${API_URL}/api/getInvoiceById/${invoiceId}`);
      setInvoice(res.data?.invoice || invoice);
      alert("Payment successful!");
    } catch (err) {
      console.error(err);
      alert("Failed to process payment. Please try again.");
    } finally {
      setPaying(false);
    }
  };

  if (loading) return <p>Loading invoice...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;
  if (!invoice) return <p>Invoice not found.</p>;

  return (
    <div style={{ padding: "20px" }}>
      <h2>Pay Invoice #{invoice.invoiceNumber}</h2>
      <p>Total Amount: Rs {invoice.totalAmount}</p>
      <p>Remaining Amount: Rs {invoice.remainingAmount ?? invoice.totalAmount}</p>
      <button onClick={handlePayment} disabled={paying} style={{ padding: "10px 20px", fontSize: "16px" }}>
        {paying ? "Processing..." : "Pay Now"}
      </button>
    </div>
  );
}

export default PayPage;
